module.exports = __webpack_public_path__ + "img/ic-play-button-small.a5e958f9.svg";